import { TBColumn } from '../../interfaces/TableBits.interfaces';
const columns: TBColumn[] = [
    {
        id: "name",
        label: 'Modelo',
        align: 'left',
        width: 40,
    },
    {
        id: "descripcion",
        label: 'Descripción',
        align: 'left',
        width: 40,
    },
    {
        id: "conteoCompetencias",
        label: 'Competencias',
        align: 'left',
        width: 20,
    },
];

export default columns;